<template lang="pug">
form#email_signup.contact-form(
  :class="embedClass",
  data-ajax-submit="//manage.kmail-lists.com/ajax/subscriptions/subscribe",
  action='//manage.kmail-lists.com/subscriptions/subscribe',
  method='GET',
  target="_blank"
  accept-charset='UTF-8',
  _lpchecked='1',
  @submit='showMessaging'
  ref="formWrapper"
  )
  input(type='hidden', name='form_type', value='customer')
  input(type='hidden', name='g', :value='listId')

  transition(name="slideOut")
    .input.input--text(v-if="notSubmitted", :class="inputClass")
      input.newsletter__input(
        type="email"
        name="email"
        id="k_id_email"
        value=""
        data-error-message="Email address must be filled out"
        placeholder=" "
        autocorrect="off"
        autocapitalize="off"
        autocomplete="email"
        v-model="emailInput"
        required
        aria-label="Email"
      )
      label.newsletter__input-label(
        for="k_id_email"
      ) Email Address
      button.newsletter__button.klaviyo_submit_button(type="submit",
        id="Subscribe", :class="buttonClass",
        :aria-label="buttonText.length ? buttonText : 'Subscribe'")
        span(v-if="buttonText.length > 0") {{ buttonText }}
        icon.icon-submit(
          v-if="icon"
          name="chevron-right"
          size="14px"
        )
  transition(name="slideIn")
    p.contact-form__success(v-if="isSuccess && message") {{ message }}


</template>

<script>
  import Icon from 'scripts/components/basic/Icon.vue'
  import FormValidation from 'scripts/helpers/formValidation.js'

  export default {
    name: 'KlaviyoForm',
    components: { Icon },
    data () {
      return {
        isSuccess: false,
        notSubmitted: true,
        emailInput: ""
      }
    },
    props: {
      message: String,
      listId: String,
      inputClass: String,
      includeIcon: String,
      buttonClass: String,
      buttonText: String,
      sendEvent: String,
      event: String,
      customProps: Object
    },
    methods: {
      showMessaging: function() {
        this.$store.dispatch('email/addEmail', this.emailInput);
        if (this.sendEvent === "true") {
          setTimeout(() => {
            this.$emit(this.event)
          }, 1000);
        }
        this.notSubmitted = false;
        setTimeout(() => {
          this.isSuccess = true;
        }, 500);
      }
    },
    computed: {
      embedClass () {
        return "klaviyo_embed_" + this.listId;
      },
      icon() {
        return this.includeIcon === "true";
      }
    },
    mounted () {
      KlaviyoSubscribe.attachToForms(this.$el, {
        hide_form_on_success: false,
        extra_properties: typeof this.customProps != "undefined" ? this.customProps : {}
        // custom_success_message: true
      });

      const requiredFields = this.$refs.formWrapper.querySelectorAll('input[required]');
      FormValidation.addFormValidation([...requiredFields]);
    }
  }
</script>

<style scoped lang="scss">
  .newsletter__klaviyo-form__input {
    margin-bottom: 32px;
  }

  ::v-deep .input-error {
    position: absolute;
    bottom: -87%;
    width: 100%;
  }

  .input.input--text label {
    left: 14px;
    background-color: $color-light-pink;

    input:placeholder-shown + & {
      left: 17px;
    }
  }

  .icon-submit {
    fill: $color-indigo;
  }

  .newsletter__button {
    cursor: pointer;
  }
</style>
